import packageJson from '../../package.json';

/** Versión del front (package.json), visible en pantalla para diagnóstico. */
export const APP_VERSION = packageJson.version;
